import { render } from "./indexSwitch.vue?vue&type=template&id=b7342a02"
import script from "./indexSwitch.vue?vue&type=script&lang=js"
export * from "./indexSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__